// extracted by mini-css-extract-plugin
export default {"root":"Home_root__+HM9Y","header":"Home_header__GEnXr","content":"Home_content__ddnYv","timelisten":"Home_timelisten__n9MpC"};